import { render } from "./RecoverPasswordPage.vue?vue&type=template&id=715c2720&scoped=true"
import script from "./RecoverPasswordPage.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordPage.vue?vue&type=script&lang=js"

import "./RecoverPasswordPage.vue?vue&type=style&index=0&id=715c2720&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715c2720"]])

export default __exports__